import { render } from "./mini-nav.vue?vue&type=template&id=52daff15"
import script from "./mini-nav.vue?vue&type=script&lang=js"
export * from "./mini-nav.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/i/i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__